module.exports = __webpack_public_path__ + "201488e070ca009f139540f0c23d33f4.pdf";